import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]
  
  connect() {
    // Page controls are sticky by default via CSS
    // This controller can be extended for scroll-based effects if needed
  }
}
